module.exports = __webpack_public_path__ + "static/media/SMARTSUPPORT_FRA-DEV-V1.0b6d07b2.xlsx";